<div class="simple-table-container" ms-responsive-table>
    <div
        class="table-title teal-600 font-size-16"
        fxLayout="row"
        fxLayoutAlign="space-between center"
    >
        <span class="saldo-disponivel-title">Saldo Disponível</span>
        <button
            mat-icon-button
            fuseWidgetToggle
            aria-label="more"
            (click)="handleBalanceClient()"
        >
            <mat-icon class="logo-icon s-24 mr-8">launch</mat-icon>
        </button>
    </div>

    <div
        class="pl-16 pr-8 py-16 light-blue-fg font-size-32"
        fxLayout="row"
        fxLayoutAlign="center center"
        style="height: 100%"
    >
        <span>
            {{
                balanceAvailable > 0
                    ? "R$ " + (balanceAvailable | number : "1.2-2")
                    : "SALDO INDISPONÍVEL"
            }}
        </span>
    </div>
</div>
